import React, { useEffect, useRef } from 'react';
import { Loader } from "@googlemaps/js-api-loader";


type GoogleMapComponentProps = {
  apiKey: string;
  latitude: number;
  longitude: number;
  zoom?: number;
};

const GoogleMapComponent: React.FC<GoogleMapComponentProps> = ({
  
  apiKey,
  latitude,
  longitude,
  zoom = 8,
}) => {
  const mapRef = useRef<HTMLDivElement>(null);


  useEffect(() => {
    const loader = new Loader({
      apiKey: "AIzaSyD3BQK4fqJwhNVoFZyk6EB1whUD-3NehqI",
      version: "weekly",

    });

    loader.load().then(() => {
      if (mapRef.current) {
        // The TypeScript type assertion is necessary here for the google.maps object
        const map = new google.maps.Map(mapRef.current, {
          center: { lat: latitude, lng: longitude },
          zoom: zoom,
        });
        new google.maps.Marker({
      position: { lat: latitude, lng: longitude },
      map: map,
      title: 'Hello World!',
    });
      }
    });
  }, [apiKey, latitude, longitude, zoom]);

  

  return <div id="map" ref={mapRef} className="h-full w-full" />;
};

export default GoogleMapComponent;
